import { JSX } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppWrapper } from "./AppWrapper";
import ProductRangePageContainer from "../pages/productRangePage/ProductRangePageContainer";
import BrandingPageContainer from "../pages/brandingPage/BrandingPageContainer";
import { RouteEnum } from "../common/enums/RouteEnum";
import ProductDetailsPageContainer from "../pages/productDetail/ProductDetailsPageContainer";
import SearchPageContainer from "../pages/searchPage/SearchPageContainer";
import { ProductGalleryModal } from "../modals/productGalleryModal/ProductGalleryModal";

function App(): JSX.Element {
    return (
        <BrowserRouter>
            <AppWrapper>
                <Routes>
                    <Route index element={<ProductRangePageContainer />} />
                    <Route
                        path={RouteEnum.PRODUCT_RANGE}
                        element={<ProductRangePageContainer />}
                    />
                    <Route
                        path={RouteEnum.PRODUCT_RANGE + "/:productId"}
                        element={<ProductDetailsPageContainer />}
                    />
                    <Route
                        path={RouteEnum.BRANDING}
                        element={<BrandingPageContainer />}
                    />
                    <Route
                        path={RouteEnum.SEARCH}
                        element={<SearchPageContainer />}
                    />
                </Routes>

                <ProductGalleryModal />
            </AppWrapper>
        </BrowserRouter>
    );
}

export default App;
